/* eslint-disable @typescript-eslint/no-require-imports */
import { addSharedLocales } from 'fourwaves-shared';

export default addSharedLocales('en', {
  countries: require('fourwaves-shared/src/core/countries.en.json'),
  provinces: require('fourwaves-shared/src/core/provinces.en.json'),
  currencies: require('fourwaves-shared/src/core/currencies.en.json'),
  fourwaves_badge: {
    powered_by: 'Powered by',
    variantA: {
      title: 'Create your <br>event in minutes',
      link: 'https://fourwaves.com/?utm_source=event-website-pill&utm_medium=banner&utm_campaign={eventId}&utm_content=create-in-minutes',
    },
    variantB: {
      title: 'Run your next event <br>with Fourwaves',
      link: 'https://fourwaves.com/?utm_source=event-website-pill&utm_medium=banner&utm_campaign={eventId}&utm_content=run-next-event',
    },
  },
  footer: {
    powered_by: 'Powered by',
    cta_button: 'Learn more',
    sub_title: 'Modernizing conferences for leading organizations',
    variantA: {
      title: 'Organizing a conference? Set up your event in minutes, not weeks.',
      link: 'https://fourwaves.com/?utm_source=event-website-footer&utm_medium=banner&utm_campaign={eventId}&utm_content=setup-in-minutes',
    },
    variantB: {
      title: 'Organizing a conference? Try the modern platform built for academics.',
      link: 'https://fourwaves.com/?utm_source=event-website-footer&utm_medium=banner&utm_campaign={eventId}&utm_content=modern-platform-for-academics',
    },
    nav_aria: 'Footer navigation',
    copyright: 'all rights reserved',
    terms_of_service: 'Terms of use',
    terms_of_service_link: 'https://fourwaves.com/terms-of-use/',
    privacy_policy: 'Privacy policy',
    privacy_policy_link: 'https://fourwaves.com/privacy-policy/',
  },
  navigation: {
    login: 'Log in',
    edit_event: 'Edit event',
  },
  live_banner: {
    title: 'The Event is Live Today',
    button: 'Access the Event',
  },
  file_upload: {
    title: 'Title',
  },
  form: {
    breadcrumb: {
      form: 'Form',
      billing: 'Payment',
      confirmation: 'Confirmation',
      submission_confirmation_header: 'Submission completed',
      registration_confirmation_header: 'Registration complete',
      waitlist_confirmation: 'You are on the waiting list',
    },
    summary: {
      submit: 'Submit',
      additional_info_content: 'For questions, please contact',
      coupon_code: 'Code',
      payment: {
        confirm_and_pay: 'Continue to payment',
        pay_now: 'Pay now',
        payment_notice: 'Payment secured by',
        total: 'Total',
        sub_total: 'Subtotal',
        billing_title: 'Billing Address',
        seller_details: 'Seller details and terms',
        email_notice: '(Receipt will be sent to this address)',
        payment: 'Payment',
        payment_method_title: 'Payment Method',
        missing_payment_methods: 'No payment method has been configured for this event.',
        coupon_code: 'Coupon Code',
        remove_coupon_code: 'Remove coupon code',
        methods: {
          credit_card: 'Credit Card',
          void: 'Skip Payment',
          deferred: 'Invoice Payment',
          forward_payment: 'Forward Payment',
        },
        gst: 'GST',
        hst: 'HST',
        qst: 'QST',
        vat: 'VAT',
        pst: 'PST',
        vat_number: 'VAT number',
        platform_fee: 'Platform fee',
        tax_rules: {
          vat0: 'VAT 0%',
          vatreversecharge0: 'VAT reverse charge 0%',
          vat25denmarkeuropereversecharge0: 'VAT reverse charge 0%',
        },
      },
      discrepancies_notice: 'The price of an item has changed. Please validate the information above.',
      edit: 'Save form',
      ongoing_upload_notice: 'Please wait while files are being uploaded.',
      blocked_edit: 'It is not possible to modify this form.',
      join_waitlist: 'Join waitlist',
      mandatory_warning_title: 'Registration Required',
      mandatory_warning_message:
        'Make sure you’re already registered for this event using the same email address before filling out your submission.',
    },
    confirmation: {
      receipt_title: 'Your receipt',
      receipt_number: 'Receipt Number',
      receipt_action: 'Download PDF',
    },
    edit_email:
      'By changing the email address, the form is transferred to a new user ({newEmail}), who will receive a notification by email. The original owner ({oldEmail}) will lose access to the form. Do you wish to continue?',
    edit_success: 'The form has been successfully saved.',
  },
  registration: {
    subtitle: 'Registration deadline is',
    subtitle_not_started: 'Registrations start',
    subtitle_closed: 'Registrations closed',
    waitlist: 'Waitlist',
    summary: 'Registration summary',
    confirmation: {
      title: 'Your form has been successfully submitted',
      subtitle: `Click the link in the confirmation email sent to <span class='util--main-color'>{email}</span> to activate your account. Sign in to access your forms and specific features on the day of the event.`,
    },
    registration_closed: {
      not_started: 'Please come back',
      logged_out_text: '<a href="{url}">Login</a> to access your registrations.',
      logged_in_text: `Go to your account to access <a href="{url}">your registrations</a>.`,
    },
    state_EventHasEnded: 'The event has ended.',
    state_FullWithWaitingList:
      'The maximum number of participants has been reached. Fill the form below to be placed on the waitlist.',
    state_Full: 'Participant limit reached.',
    state_PeriodHasEnded: 'Registration period is finished.',
    state_PeriodDidNotStart: 'The registration period has not started.',
  },
  submission: {
    subtitle: 'Submission deadline is',
    subtitle_not_started: 'Submissions start',
    subtitle_closed: 'Submissions closed',
    submission_period_finished: 'The submission period is closed.',
    confirmation: {
      title: 'Your form has been successfully submitted',
      subtitle: `Click the link in the confirmation email sent to <span class='util--main-color'>{email}</span> to activate your account. Sign in to access your forms and specific features on the day of the event.`,
    },
    submission_closed: {
      not_started: 'Please come back',
      logged_out_text: '<a href="{url}">Login</a> to access your submissions.',
      logged_in_text: `Go to your account to access <a href="{url}">your submissions</a>.`,
    },
    state_EventHasEnded: 'The event has ended.',
    state_FullWithWaitingList:
      'The maximum number of submissions has been reached. Fill the form below to be placed on the waitlist.',
    state_Full: 'Submission limit reached.',
    state_PeriodHasEnded: 'Submission period is finished.',
    state_PeriodDidNotStart: 'The submission period has not started.',
  },
  validation: {
    required: 'This field is required.',
    is: 'This field must be identical.',
    email: 'Your email address must be valid.',
    rte_max_length: 'You entered too many words. Please shorten the input.',
  },
  global: {
    apply: 'Apply',
    show_more: 'Show more',
    save: 'Save',
    cancel: 'Cancel',
    words: 'Words',
    edit: 'Edit',
    first_name: 'First name',
    last_name: 'Last name',
    name: 'Name',
    email: 'Email',
    company: 'Company / Organization',
    add: 'Add',
    unavailable: 'Unavailable',
    by: 'by',
    to: 'To',
    subject: 'Subject',
    body: 'Message',
    fw_statement_descriptor: 'Your credit card statement will show a charge from FOURWAVES EVENTS.',
    address: {
      street: 'Street address',
      city: 'City',
      country: 'Country',
      province: 'Province/State',
      postal: 'Postal/ZIP',
    },
    payment_methods: {
      stripe: 'Online (Stripe)',
      paysafe: 'Online (Paysafe)',
      alipay: 'Online (Alipay)',
      bypass: 'Skip',
      invoicing: 'Invoicing',
      publisoft: 'Online (Publisoft)',
      void: 'Void',
      touchnet: 'TouchNet',
      globalpayments: 'Global Payments',
      moneris: 'Moneris',
      paypal: 'PayPal',
    },
    transaction_status: {
      refund: {
        concluded: 'Refunded',
        pending: 'Pending',
        canceled: 'Canceled',
      },
      charge: {
        concluded: 'Paid',
        pending: 'Pending',
        canceled: 'Unpaid',
      },
    },
    review_status: {
      title: 'To review',
      unassigned: 'Unassigned',
      pending: 'Pending',
      conflictofinterest: 'Conflict of interests',
      completed: 'Completed',
    },
    transaction_type: {
      refund: 'Refund',
      payment: 'Payment',
    },
    event_information: 'Event information',
    home: 'Home',
    password: 'Password',
    login_success: 'You are successfully logged in',
    no_location: 'No location',
    online_event: 'Online event',
    hybrid_event: 'Hybrid event',
    loading: 'Loading data...',
    pagination_prev: 'Previous',
    pagination_next: 'Next',
    pagination_display: 'Display',
    forgot: 'Forgot password or Activate your account',
    send: 'Send',
    forgot_password: 'Forgot your password?',
    forgot_password_success: 'Please check your inbox.',
    download: 'Download',
    read_more: 'Read more',
    close: 'Close',
    from: 'from',
    learn_more: 'Learn more',
    clear_filters: 'Clear filters',
    filters: 'Filters',
    hide_filters: 'Hide filters',
    select_default_placeholder: 'Select an option',
    link_opens_in_new_tab: 'This link will open in a new tab',
  },
  event_details: {
    location: 'Location',
    dates: 'Dates',
    registration_period: 'Registration period',
    submission_period: 'Submission period',
    contact: 'Contact us',
    contact_message: 'If you have any questions, please contact',
  },
  participants: {
    participant: 'No participants | {count} participant | {count} participants',
    message: 'This page lists the participants registered to the event.',
    no_results: 'There are no participants to show',
    search_placeholder: 'Search',
    photo_of: 'Photo of ',
    registration_deadline_is: 'Registration deadline is',
    bookmark_filter: 'My connections',
    online_filter: 'Online',
    back_to_list: 'Back',
    placeholder_text: 'No information available.',
    listing_options: {
      alphabetical: 'A - Z',
    },
  },
  poster_hall: {
    title: 'Poster Hall',
  },
  abstracts: {
    upvote: '0 upvotes | 1 upvote | {count} upvotes',
    bookmark: 'Bookmark',
    bookmarked: 'Bookmarked',
    bookmark_filter: 'Bookmarked',
    comment: '0 comments | 1 comment | {count} comments',
    schedule_filter: 'Session',
    schedule_filter_all: 'See all',
    search_placeholder: 'Search',
    total_count: 'No presentations | {count} presentation | {count} presentations',
    no_presentations: 'No presentations.',
    abstract: 'Details',
    figures: 'Figures',
    slides: 'Slides',
    poster: 'Poster',
    video: 'Video',
    back_to_list: 'Back to list',
    in_discussion: 'in discussion',
    call_presenter: 'Call presenter',
    join: 'Join',
    join_conversation: 'Join conversation',
    enter_conversation: 'Enter conversation room',
    listen_conversation: 'Listen to video conversation',
    open_for_discussion: 'Open for discussion',
    presented_by: 'Presented by ',
    by: 'By',
    presenting_now: 'Presenting now',
    sign_in_to_contact: 'Log in to contact',
    contact: 'Contact',
    contact_presenter_modal: {
      title: 'Contact Presenter',
      send_email: 'Send Email',
      success_message: 'Email sent.',
    },
    login_cta: {
      join_conversation: 'The event is live. Join the conversation.',
      need_to_signed: 'You need to be logged in to participate.',
      sign_in: 'Log in',
      already_registered: 'Already registered?',
      activate_your_account: 'Activate your account',
      not_registered: 'Need to register?',
      open_registration: 'Register now',
    },
    schedule_presentations: {
      title: 'Scheduled in {count} session | Scheduled in {count} sessions',
      description: '* All times are based on',
    },
    other_information: 'Other information',
    listing_options: {
      numerical: '1 - 9',
      alphabetical: 'A - Z',
      upvotes: 'Top voted',
    },
    picture_layout: 'Image view',
    list_layout: 'List view',
    enable_laser: 'Enable laser pointer',
    disable_laser: 'Disable laser pointer',
    follow: 'Follow',
    following: 'Following',
    preparing_poster: 'Poster loading',
    no_results: 'There are no presentations that match your filters.',
  },
  schedule: {
    title: 'Schedule',
    no_schedule: 'There are no sessions to show.',
    time_zone_details: '* All times are based on',
    types: {
      postersession: 'Poster session',
      keynote: 'Keynote',
      oral: 'Oral',
      panel: 'Panel',
      workshop: 'Workshop',
      networking: 'Networking',
      break: 'Break',
      other: 'Other',
    },
    sign_to_access_room: 'Log in to access room',
    register_to_access_room: 'Register to access room',
    back_to_list: 'Back',
    only_participant_can_access_rooms: 'Only registered participants can access the room',
    live: 'Live',
    now: 'Now',
    virtual: 'Virtual',
    minute_countdown: 'In {count} min',
    hour_countdown: 'In {count} hour | In {count} hours',
    day_countdown: 'In {count} day | In {count} days',
    tomorrow: 'Tomorrow',
    cta_poster: 'Go to Poster Hall',
    cta_livestream: 'Join livestream',
    presentation: {
      title: 'Presentations',
      show_all_in_presentations: 'View all in the presentations page',
      no_results: 'There are no presentations in this session.',
    },
    bookmark: 'Bookmark',
    unbookmark: 'Unbookmark',
    bookmarked: 'Bookmarked',
    parallel_sessions: '{count} parallel sessions',
  },
  conferencing: {
    conversation: {
      browser_limitation: `The browser you're using ({browser}) is not compatible.`,
    },
    confirm_quit: 'You are currently on a virtual call, do you really want to quit?',
    video_call_request_title: 'Conversation request',
    video_call_request_join: 'Join',
    video_call_request_decline: 'Decline',
  },
  questions_and_answers: {
    acronym: 'Q&A',
    title: 'Ask a question',
    edit: 'Edit',
    delete: 'Delete',
    presenter: 'Presenter',
    reply_btn: 'Reply',
    edit_btn: 'Edit',
    cancel_btn: 'Cancel',
    submit_btn: 'Submit',
    textarea_message_placeholder: 'Your question',
    textarea_reply_placeholder: 'Your reply',
    textarea_placeholder: 'Ask a question',
    success_message: {
      added: 'Comment added',
      updated: 'Comment edited',
      deleted: 'Comment deleted',
      delete_all: 'The questions were successfully removed',
    },
    must_be_logged_in: 'You must be logged in to interact.',
    clear_messages: 'Clear all questions',
    clear_messages_confirm: 'Do you really want to clear all questions?',
  },
  hints: {
    payment_void: 'Waive the payment for this transaction. This option is visible to organizers only.',
    payment_forward:
      '{firstName} ({email}) will receive a notification to complete the payment. This option is visible to organizers only.',
  },
});
